import { BaseModel, ModelInstance, ToFrontHook, ToBackHook, enumField, DateTimeField } from './util';
import { Organization } from './organization';
import { Locales } from '../localization/locales';


export enum OrganizationBillStatuses {
  pending = 1,
  paid,
  canceled,
}

export const OrganizationBillStatusLocalization = {
  [Locales.ru]: {
    [OrganizationBillStatuses.pending]: 'Новый',
    [OrganizationBillStatuses.paid]: 'Оплачен',
    [OrganizationBillStatuses.canceled]: 'Отменен',
  },
  [Locales.en]: {
    [OrganizationBillStatuses.pending]: 'New',
    [OrganizationBillStatuses.paid]: 'Paid',
    [OrganizationBillStatuses.canceled]: 'Canceled',
  }
};

@ModelInstance({
  mappingFields: {
    id: 'id',
    organization: 'organization',
    status: 'status',
    sum: 'sum',
    payment_date: 'paymentDate',
    pay_till_date: 'payTillDate',
    date_from: 'dateFrom',
    date_to: 'dateTo',
    created_at: 'createdAt',
  },
  relation: {
    organization: Organization,
    status: enumField(OrganizationBillStatuses),
    paymentDate: DateTimeField,
    payTillDate: DateTimeField,
    dateFrom: DateTimeField,
    dateTo: DateTimeField,
    createdAt: DateTimeField,
  }
})
export class OrganizationBill extends BaseModel {
  id: number;
  organization: Organization;
  status: OrganizationBillStatuses;
  sum: number;
  paymentDate: Date;
  payTillDate: Date;
  dateFrom: Date;
  dateTo: Date;
  createdAt: Date;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
